import type { CSSProperties } from 'react'

import { formatMoney } from '../../pricing/model/format'
import { BASE_LABEL_HEIGHT_MM, EMPTY_NAME_TEXT } from '../model/constants'
import { encodeBarcode } from '../model/barcode'
import type { LabelTemplate } from '../model/templates'
import { BarcodeSvg } from './BarcodeSvg'

/**
 * Одна этикетка ценника (карточка 102, макет донора `modules/labels`):
 * наименование, цена склада, штрихкод с цифрами — и больше ничего. Размеры в
 * миллиметрах для 30×20 и растягиваются по высоте (`--k`): крупный ценник —
 * тот же макет. Жирные цифры штрихкода обязательны: тонкие при 203 dpi выпадают.
 */
export function PriceTag({
  name,
  price,
  barcode,
  template,
}: {
  name: string
  price: number
  barcode: string
  template: LabelTemplate
}) {
  const style = {
    width: `${template.widthMm}mm`,
    height: `${template.heightMm}mm`,
    '--k': template.heightMm / BASE_LABEL_HEIGHT_MM,
  } as CSSProperties

  // «89,90 ₽»: знак рубля мельче цифр — так цена читается с расстояния полки.
  const money = formatMoney(price)
  const amount = money.replace(/\s*₽$/, '')
  const encoded = encodeBarcode(barcode)

  return (
    <article className={template.accent ? 'onec-tag onec-tag--accent' : 'onec-tag'} style={style}>
      {/* Наименование — дословно из 1С (ADR-8), до трёх строк. */}
      <span className="onec-tag__name">{name.trim() === '' ? EMPTY_NAME_TEXT : name}</span>
      <span className="onec-tag__price">
        {amount}
        {amount !== money && <span className="onec-tag__currency"> ₽</span>}
      </span>
      {encoded !== null && (
        <>
          <BarcodeSvg className="onec-tag__barcode" value={barcode} />
          <span className="onec-tag__digits">{encoded.text}</span>
        </>
      )}
    </article>
  )
}
